import moment from "moment";
import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function getListFuel(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/combustible/list-combustible",
            API_BASE_URL + "/combustible/list-combustible",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                    data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.descripcion,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("getListFuel err");
        console.log(err);
        return [];
    }
}

export async function createFuel(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/combustible/create-combustible",
            API_BASE_URL + "/combustible/create-combustible",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createFuel err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function disableFuel(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/combustible/disable-combustible",
            API_BASE_URL + "/combustible/disable-combustible",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableFuel err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function enableFuel(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/combustible/enable-combustible",
            API_BASE_URL + "/combustible/enable-combustible",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("enableFuel err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function updateFuel(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/combustible/update-combustible",
            API_BASE_URL + "/combustible/update-combustible",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updateFuel err");
        console.log(err);
        return { error: true, message: err };
    }
}